<template>
	<div class="col-12">
		<div class="card card-settings">
			<div class="card-header card-header-tabs-custom">
				<h3 class="card-title p-3">Gestión de Permisos</h3>
			</div>
			<div class="card-body">
				<form @submit.prevent="triggerSave">
					<div class="row mb-3">
						<div class="col-md-6">
							<div class="info-box bg-light py-2 min-h-reset">
								<span class="info-box-icon bg-info elevation-1"><i class="fas fa-id-card"></i></span>
								<div class="info-box-content">
									<span class="info-box-text text-sm">Perfil</span>
									<span class="info-box-number text-md">{{ form.name }}</span>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<div class="info-box bg-light py-2 min-h-reset">
								<span class="info-box-icon bg-warning elevation-1"><i class="fas fa-users"></i></span>
								<div class="info-box-content">
									<span class="info-box-text text-sm">Usuarios Afectados</span>
									<span class="info-box-number text-md">{{ form.users.length }}</span>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-12">
							<div v-for="(group, groupName) in permissions" :key="groupName" class="card mb-2 shadow-none border">
								<div class="card-header bg-light py-1 px-3 d-flex justify-content-between align-items-center">
									<h6 class="mb-0 text-capitalize font-weight-bold text-secondary" style="font-size: 0.9rem;">
										<i class="fas fa-layer-group mr-2"></i> {{ groupName }}
									</h6>
									<button type="button" class="btn btn-xs btn-outline-primary" @click="toggleGroup(group)">
										<i class="fas fa-check-double"></i> Todo
									</button>
								</div>
								<div class="card-body py-2 px-3">
									<div class="row">
										<div class="col-md-3 col-sm-6 mb-1" v-for="(permission, index) in group" :key="index">
											<div class="custom-control custom-switch">
												<input type="checkbox" class="custom-control-input" :id="'perm_' + permission.id" :value="permission.id" v-model="form.permissions">
												<label class="custom-control-label text-sm font-weight-normal" :for="'perm_' + permission.id">{{ permission.name }}</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<hr>
					<div class="col-md-12 d-flex justify-content-between">
						<router-link to="/permissions" class="btn btn-outline-secondary">
							<i class="fas fa-arrow-left"></i> Regresar
						</router-link>
						<button type="submit" class="btn btn-success px-5">
							<i class="fas fa-save"></i> Guardar Cambios
						</button>
					</div>
					<br>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import request from '../../services/request'
import { mapActions } from 'vuex';

export default {
	name: "permissions-form",
	data() {
		return {
			form: {
				id: '',
				name: '',
				users: [],
				permissions: []
			},
			permissions: [],
		}
	},
	methods: {
		async getProfileId(id) {
			let service = request;
			let _endpoint = '/profiles/' + id;
			try {
				let { data } = await service.get(_endpoint)
				if (data) {
					this.form.id = data.id;
					this.form.name = data.name;
					// this.form.area = data.area; // Removed
					// this.form.profil = data.profil; // Removed
					this.form.users = data.users;
					if (data.permissions) {
						var res = data.permissions.map(s => s.id);
						this.form.permissions = res;
					}
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		async getPermissions() {
			let service = request;
			let _endpoint = '/catalogue/permissions';
			try {
				let { data } = await service.get(_endpoint)
				if (data) {
					this.permissions = data;
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		async triggerSave() {
			let _endpoint = '/profiles';
			if (this.form.id != "") {
				this.form._method = 'PUT';
				_endpoint = `/profiles/${this.form.id}`;
			}

			try {
				let { data } = await request.post(_endpoint, this.form)
				if (data) {
					this.successNotification(data.message);
					this.$router.push('/permissions');
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		toggleGroup(group) {
			// Check if all permissions in this group are already selected
			const allSelected = group.every(p => this.form.permissions.includes(p.id));
			
			if (allSelected) {
				// Deselect all
				this.form.permissions = this.form.permissions.filter(id => !group.find(p => p.id === id));
			} else {
				// Select all
				group.forEach(p => {
					if (!this.form.permissions.includes(p.id)) {
						this.form.permissions.push(p.id);
					}
				});
			}
		},
		...mapActions({
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		})
	},
	mounted() {
		this.getPermissions();
		let id = this.$route.params.id;
		if (id) {
			this.getProfileId(id);
		}
	},
}
</script>
<style>

</style>
